import React from 'react';
import { Table, TableHead, TableHeaderCell } from 'src/components';
import { IMandatedSignatory } from 'src/models';
import { SignatoryTableRow } from './components';
import { t } from 'i18next';

interface ISignatories {
  signatories: IMandatedSignatory[];
}

const Signatories = ({ signatories }: ISignatories) => {
  return (
    <Table role="table">
      <TableHead role="head">
        <tr role="row">
          <TableHeaderCell>{t('MandateSignatories')}</TableHeaderCell>
        </tr>
      </TableHead>
      <tbody role="rowgroup">
        {signatories.map((signatory, index) => (
          <SignatoryTableRow key={index} signatory={signatory} />
        ))}
      </tbody>
    </Table>
  );
};

export default Signatories;
